import { useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { api, formatApiError } from "@/lib/api";

export function DemoPurgeCard({ onDone }: { onDone: () => void }) {
  const [busy, setBusy] = useState(false);
  const purge = async () => {
    setBusy(true);
    try {
      const { data } = await api.post<{ deleted_users: number }>("/admin/demo-users/purge");
      toast.success(`Usuarios demo eliminados: ${data.deleted_users}`);
      onDone();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm sm:p-7" data-testid="demo-purge-card">
      <h3 className="font-display text-base font-bold text-[#1B2A4A]">Usuarios demo</h3>
      <p className="mt-1 text-sm text-slate-500">Antes de publicar, elimina admin.demo, mariana.demo y diego.demo con todos sus datos. No se vuelven a crear.</p>
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <Button variant="outline" disabled={busy} className="mt-4 border-[#B23A1E]/40 text-[#B23A1E] hover:bg-[#F8ECE8]" data-testid="demo-purge-button">
            <Trash2 className="mr-2 h-4 w-4" /> Eliminar usuarios demo
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent className="bg-white">
          <AlertDialogHeader>
            <AlertDialogTitle>¿Eliminar los usuarios demo?</AlertDialogTitle>
            <AlertDialogDescription>Se borran los tres usuarios demo y todos sus datos. Esta acción no se puede deshacer.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="demo-purge-cancel">Cancelar</AlertDialogCancel>
            <AlertDialogAction onClick={purge} className="bg-[#B23A1E] hover:bg-[#9a3119]" data-testid="demo-purge-confirm">Eliminar</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
